import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import signin from './Login.module.css';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../utils/firebase';
import account from "../AccountSettings/AccountSettings.module.css";

const SignIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/app');
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <div className={signin['signin-container']}>
            <div className={signin['signin-form']}>
                <h2>Sign In</h2>
                <form onSubmit={handleSubmit}>
                    <div className={signin['form-group']}>
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className={signin['form-group']}>
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button type="submit" className={signin['signin-button']}>Sign In</button>
                </form>
            </div>

            <div className={signin['signup-footer']}>
                <button
                    onClick={() => navigate("/")}
                    className={account['text-link']}
                    style={{ background: "none", border: "none", color: "inherit", cursor: "pointer" }}
                >
                    Return to Home
                </button>
                <button
                    onClick={() => navigate("/auth/signup")}
                    className={account['text-link']}
                    style={{ background: "none", border: "none", color: "inherit", cursor: "pointer" }}
                >
                    Sign Up
                </button>
                <button
                    onClick={() => navigate("/auth/account/utils/password/reset")}
                    className={account['text-link']}
                    style={{ background: "none", border: "none", color: "inherit", cursor: "pointer" }}
                >
                    Forgot Password
                </button>
            </div>
        </div>
    );
};

export default SignIn;